export default __webpack_public_path__ + "static/comforting-3441da507de035b7dd5d5198bf85c20c.svg";